import React from 'react';
import Reflux from 'reflux';

import CuesheetTrackingStore from 'flux/stores/cuesheet/CuesheetTrackingStore';
import CuesheetTrackingActions from 'flux/actions/cuesheet/CuesheetTrackingActions';

import { Icon } from '@shoflo-rundown/polymer.legacy';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';

/**
 * A component for allowing a show caller to resume their last position of tracking focus
 *
 */
export default React.createClass({
  displayName: 'TrackingResumeButton',

  mixins: [Reflux.connect(CuesheetTrackingStore, 'cuesheetTracking')],

  render() {
    const state = this._getState();

    let trackingResumeAvailable = state.get('trackingResumeAvailable');
    let selectedTrackableUser = state.get('selectedTrackableUser');
    let trackingEnabled = state.get('trackingEnabled');

    const isEnabled =
      trackingResumeAvailable || (selectedTrackableUser && trackingEnabled);
    if (!isEnabled) return <span />;

    return (
      <a className="cs-tracking-resume-link" onClick={this._handleClick}>
        <WithTooltip
          placement="top"
          delay={500}
          tip={TooltipConstants.CSReturnToTrackingLink}
        >
          <Icon className="cs-tracking-resume-icon" name="share" />
        </WithTooltip>
      </a>
    );
  },

  _handleClick() {
    CuesheetTrackingActions.resumeTrackingPosition();
  },

  _getState() {
    return this.state.cuesheetTracking;
  },
});
